import { render } from "./UclVue.vue?vue&type=template&id=cfe472a8"
import script from "./UclVue.vue?vue&type=script&lang=js"
export * from "./UclVue.vue?vue&type=script&lang=js"

import "./UclVue.vue?vue&type=style&index=0&id=cfe472a8&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__